import { TabBookingAbstract } from './tabBookingAbstract'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import { dateCompare, dateCompareYMD, mergeArray, multiply } from '@/utils/commonUtil'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import StrUtils from '@/utils/StrUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { queryCustomerRemarksHistory } from '@/api/SeaImport/seaImportJob'
import { ClosingAccount } from '@/class/model/act/ClosingAccount'
import { AbstractEntity as WarehouseInfo } from '@/class/model/AbstractEntity'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { TabError } from '@/utils/class/TabError'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { OS_BOOKING_TYPE } from '@/class/cargo/model/parameters/BookingTerm'
import { ImportConstants } from '@/class/cargo/model/utils/ImportConstants'
import { Contract } from '@/class/model/mdm/Contract'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import { getWarehouseDetail } from '@/api/company'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { BULK_CARGO_TYPE } from '@/class/cargo/model/parameters/ImportConstants'
import { cache } from '@/utils/cacheManager'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment'
import { CHARGE_SOURCE_SPLIT } from '@/class/cargo/model/parameters/SystemConstants'
import $store from '@/store'

export class BasicTabHP extends TabBookingAbstract {
  constructor(view) {
    super(view)

    this.isSpecifiedSalesBusiness = false // 是否启用合作伙伴对应的服务人员设置(多销售模式)

    this.defaultChargeCubage = 0 // 默认计费体积 m³
    this.isWithinCloseAccountDate = false // 关账控制
    this.formInitialValue = {} // 表单的初始值（用于判断表单字段是否被修改）
    /**
     * 是否是小票
     */
    this.lclMasterFlag = true

    this.cutomJobTypeList = [] // 自定义业务类型
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  get user() {
    return this.context.user
  }
  set user(user) {
    // 不可赋值
  }

  async changeJob() {
    if (!this.isSpecifiedSalesBusiness) {
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
      }
    } else {
      this.loadUser()
    }
    this.formInitialValue = { ...this.job }
    // 主分单 付款地址 已从后端关联取出来
  }
  async loadUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadUserHandler(data)
        })
      } else {
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }
        this.getTxtSalesPrompt()
      }
    }
  }
  async loadUserHandler(companyUsers) {
    const salesList = []
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.view.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
    }
    if (companyUsers !== null && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (u.lob === this.job.lob || StrUtils.isEmpty(u.lob) || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user != null) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) {
              if (this.view.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    salesList.push(user)
                  }
                }
              } else {
                salesList.push(user)
              }
            }
          }
        }
      }
    }

    this.view.salesList = salesList

    this.getTxtSalesPrompt()
  }
  init() {
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1

    this.view.branchOfficeCheck = Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.view.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1

    this.defaultChargeCubage = Number(this.config.get('ImportChargeCubageMT'))

    getSpecificBasicData(basicCacheKeys.basic_data_CutomJobType).then(data => {
      this.cutomJobTypeList = data
    })
  }

  /**
   * @private
   * 新增信息
   */
  async updateModel() {
    if (!this.view.isEdit) return
    const _importJob = this.job
    const oldJob = this.formInitialValue
    const isNewInstance = StrUtils.isEmpty(_importJob.uuid)

    if (isNewInstance) {
      _importJob.jobState = 0
      _importJob.typeHBL = _importJob.signHBL ? 1 : 0
      _importJob.typeMBL = _importJob.signMBL ? 1 : 0
      this.paymentPlaceBLShowChange()
      this.portChange().then(r => {
      })
    }

    _importJob.masterFlag = false
    _importJob.opOffice = this.view.$store.getters.currentOfficeId
    _importJob.lob = 'SI'

    if (!this.view.visibleDesignationAgent) {
      _importJob.designationAgent = 0
    }

    if (_importJob.csr === 0) {
      _importJob.csrOffice = 0
      _importJob.csrDepartment = 0
    }
    if (_importJob.dc === 0) {
      _importJob.dcOffice = 0
      _importJob.dcDepartment = 0
    }

    await this.getWarehouseInfo()

    const seaCargoMark = parseInt(cache.config.get('seaCargoMark'))
    const hdoc = await new SeaImportJob(_importJob).getMainHbl(true)
    const billOfLadingSynMode = Number(cache.config.get('BillOfLadingSynMode'))
    if (hdoc) {
      hdoc.hblNbr2 = _importJob.hbl
      hdoc.freightTermHBL = _importJob.freightTermHBL
      hdoc.paymentPlaceBL = _importJob.paymentPlaceHbl
      if ([1, 2].includes(billOfLadingSynMode)) {
        hdoc.packing = _importJob.packing
      }
      if (hdoc.quantity > 0) {
        let packingName = ''
        if (hdoc.packing) {
          const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', hdoc.packing)
          packingName = packing ? packing.name : ''
        }
        hdoc.quantitySum = StrUtils.jsdx(hdoc.quantity, packingName)
      }
      const hdoc2 = await new SeaImportJob(_importJob).getCargoDocByType(CargoDocConsts.HBL2, false)
      if (hdoc2) {
        hdoc2.paymentPlaceBL = hdoc.paymentPlaceBL
      }
      hdoc.containerSum = ContainerUtil.getSeaeqNumberStr(_importJob)
      if (!hdoc.uuid || !hdoc.mark || (seaCargoMark === 1 && _importJob.mark !== oldJob.mark)) {
        hdoc.mark = _importJob.mark
      }
    }
    const mdoc = await new SeaImportJob(_importJob).getMainMbl(true)
    if (mdoc) {
      mdoc.freightTermHBL = _importJob.freightTermMBL
      mdoc.paymentPlaceBL = _importJob.paymentPlaceMbl
      if ([1, 2].includes(billOfLadingSynMode)) {
        mdoc.packing = _importJob.packing
      }
      if (mdoc.quantity > 0) {
        let packingName = ''
        if (mdoc.packing) {
          const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', mdoc.packing)
          packingName = packing ? packing.name : ''
        }
        mdoc.quantitySum = await StrUtils.jsdx(mdoc.quantity, packingName)
      }
      if (!mdoc.uuid || !mdoc.mark || (seaCargoMark === 1 && (!mdoc._mergeHblDataTime || (mdoc._markTime && mdoc._markTime > mdoc._mergeHblDataTime)) && _importJob.mark !== oldJob.mark)) { mdoc.mark = _importJob.mark }
      const mdoc2 = await new SeaImportJob(_importJob).getCargoDocByType(CargoDocConsts.MBL2, false)
      if (mdoc2) {
        mdoc2.paymentPlaceBL = hdoc.paymentPlaceBL
      }
      mdoc.containerSum = ContainerUtil.getSeaeqNumberStr(_importJob)
    }

    // 保存提单地址
    if (parseInt(cache.config.get('syncMailingAddress')) === 1) {
      ImportConstants.saveBillAddress(this.job)
    }
  }

  /**
   * @public
   * 输入验证
   */
  async checkModel() {
    const form = this.job
    if (form.customerId < 1) {
      if (this.view.visibleDesignationAgent) {
        throw new TabError(this.view.$t('SeaExport.checkActualNotifyParty'), 'basicTab')
      } else {
        throw new TabError(this.view.$t('SeaExport.checkConsignationCompany'), 'basicTab')
      }
    }
    await JobUtils.checkCustomerBranchScope(form, 'basicTab')
    await SecurityUtil.companyisActive(this.view.$t('SeaExport.Customer'), form.customerId, 'basicTab')

    if (this.view.visibleDesignationAgent) {
      if (form.designationAgent < 1) {
        this.view.$nextTick(() => {
          this.view.$refs.designationAgent.$refs.company.$refs.advanceSelectRef.focus()
        })
        throw new TabError(this.view.$t('SeaExport.checkNominatedAgent'), 'basicTab')
      }
    }

    if (!form.loadingPortCode) {
      this.view.$nextTick(() => {
        this.view.$refs.loadingPortCode.$refs.advanceSelectRef.focus()
      })
      throw new TabError(this.view.$t('SeaExport.checkLoadingPort2'), 'basicTab')
    }

    if (!form.dischargingPortCode) {
      throw new TabError(this.view.$t('SeaExport.checkPortOfDischarge'), 'basicTab')
    }

    if (!form.destinationPortCode) {
      throw new TabError(this.view.$t('Message.PlaceOfDeliveryCannotBeNull'), 'basicTab')
    }

    // if (!form.destinationPlace) {
    //   throw new TabError(this.view.$t('SeaExport.checkFinalDestination'), 'basicTab')
    // }

    // CARGO-54612 海创：海运进口ETD设置非必填，实际通知人改成委托单位【ui自定义开启时，且海进操作页签，前端不强制校验etd】
    if (!(this.view.viewSource === 'bookingWorkspace' && this.view.$store.state.uiCustom.enable) && !form.etd) {
      throw new TabError(this.view.$t('SeaExport.DateOfDeparture') + this.view.$t('queryJob.CannotBeEmpty'), 'basicTab')
    }

    if (!form.eta) {
      throw new TabError(this.view.$t('SeaExport.DateOfArrival') + this.view.$t('queryJob.CannotBeEmpty'), 'basicTab')
    }

    if (form.etd && form.eta && form.eta < form.etd) {
      throw new TabError(this.view.$t('SeaExport.checkDateOfDepartureAndDateOfArrival'), 'basicTab')
    }

    // 日期格式验证
    /* if (view.dfCustDate.selectedDate != null || view.dfCustDate.text != "")
      {
        if (!ImportConstants.getInstance().validateDate(view.dfCustDate,ResourceManager.getInstance().getString("SeaExport","BillExchangeDate")))
        {
          return false;
        }
      }*/

    if (form.cargoSource === 'SC' || parseInt(this.config.get('NorminationJobSaleType')) === 1) {
      if (!form.sales || form.sales === 0) {
        throw new TabError(this.view.$t('SeaExport.checkSales'), 'basicTab')
      }
      if (!form.salesOffice || form.salesOffice <= 0) {
        throw new TabError(this.view.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'basicTab')
      }
      if (!form.salesDepartment) {
        throw new TabError(this.view.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'basicTab')
      }
    } else {
      if (form.sales && !form.salesDepartment) {
        throw new TabError(this.view.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'basicTab')
      }
    }

    if (!form.opDepartment || form.opDepartment === 0) {
      throw new TabError(this.view.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'basicTab')
    }

    if (form.bookingAgent) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.BillExchangeAgent'), form.bookingAgent, 'basicTab')
    }
    if (form.destinationAgent) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.PortOfLoadingAgent'), form.destinationAgent, 'basicTab')
    }

    if (form.cargoSource === 'NC' && !form.designationAgent) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.NominatedAgent'), form.destinationAgent, 'basicTab')
    }

    if (form.customsBroker) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.CustomsBroker'), form.customsBroker, 'basicTab')
    }
    if (form.warehouseCmp) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.Warehouse'), form.warehouseCmp, 'basicTab')
    }
    if (form.carrierId) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.ShippingCompany'), form.carrierId, 'basicTab')
    }
    if (form.customerId > 0) {
      const c = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (c == null || !c.customer || !c.active) {
        throw new TabError('【' + c.chineseName + '】' + this.view.$t('Message.no') + this.view.$t('SeaExport.ConsignationCompany') +
            ', ' + this.view.$t('pleaseSelectAgain.no'), 'basicTab')
      }
      if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
        throw new TabError(this.view.$t('CargoMsg.Cargo_CustomerNotOwn'), 'basicTab')
      }
    }
    // 中邮定制字段 保存校验
    if (this.view.isZY && !form.saleProductCode) {
      throw new TabError(this.view.$t('Message.SaleProductCodeCannotBeNull'), 'basicTab')
    }
    if (this.view.isZY && !form.fullOrInside) {
      throw new TabError(this.view.$t('Message.FullOrInsideCannotBeNull'), 'basicTab')
    }
    return true
  }
  /**
   * 更新页面显示
   */
  updateView() {
    if (this.job.cargoSource === null || this.job.cargoSource === 'NC') {
      this.view.visibleDesignationAgent = true
      this.view.customerLabel1 = this.view.$t('SeaExport.ActualNotifyParty')
      this.view.customerLabel2 = this.view.$t('SeaExport.ActualNotifyPartyHeader')
    } else {
      this.view.visibleDesignationAgent = false
      this.view.customerLabel1 = this.view.$t('SeaExport.ConsignationCompany')
      this.view.customerLabel2 = this.view.$t('SeaExport.ConsignationCompanyHeader')
    }

    // 信控超期提醒
    this.checkCredit()

    this.view.isTwoVessel = this.job.secondVessel != null && this.job.secondVessel !== ''

    const model = this.job
    // 判断是否有主票信息
    if (model.lclMasterUuid) {
      this.lclMasterFlag = false
    } else {
      this.lclMasterFlag = this.view.isEdit
    }

    const isNewInstance = StrUtils.isEmpty(model.uuid)
    if (isNewInstance) {
      // CARGO-30761  环海：海运进口运输条款默认设置
      if (!model.freightTermHBL) {
        if (model.containerLoadType === 'LCL') {
          model.freightTermHBL = 'CFS-CFS'
          model.trans = true
        } else {
          model.freightTermHBL = 'CY-CY'
        }
      }
      // ocr 是会传值的
      if (model.salesChannel !== SystemConstants.SALES_CHANNEL_OCR_RECOGNITION.code) {
        model.incoTerm = ''
      }

      this.cubageFocusInHandler(false)
      // cargo 控件自动默认第一个下来数据 -或第一次初始化控件值，h5手工处理
      if (!model.bookingTerm) {
        model.bookingTerm = OS_BOOKING_TYPE.code
      }
      if (!model.tradeTerm) {
        const list = getCacheListByKey(basicCacheKeys.basic_data_TradeTerm)
        if (list && list.length > 0) {
          model.tradeTerm = list[0].code
        }
      }
      if (!model.freightTermMBL) {
        const list = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
        if (list && list.length > 0) {
          model.freightTermMBL = list[0].code
        }
      }
      if (!model.cargoType) {
        model.cargoType = 'GC'
      }
      JobUtils.matchUserPortConfig(this.view, model)
      JobUtils.matchRegionWarehouseMappingConfig(model, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, null, true)
    } else {
      JobUtils.matchUserPortConfig(this.view, model, false, null, { keepOriginValue: true })
    }
    this.view.controllerEnable.qCargoType = this.lclMasterFlag // 主票 下新增小票时 也不允许修改类型 || isNewInstance
    this.view.controllerEnable.dfETD = (!model.transDate) && this.view.isEdit
    this.view.controllerEnable.txtCustomerId = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'customerId')
    this.view.controllerEnable.txtDesignationAgent = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'designationAgent')
    this.view.controllerEnable.txtBookingAgent = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'bookingAgent')
    this.view.controllerEnable.txtCarrierId = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'carrierId')
    this.view.controllerEnable.txtChargeWeight = this.view.isEdit && SecurityUtil.checkOffsetChargeMeasure(model, 'WGTX')

    // 查询收发通信息
    // todo ImportConstants.getInstance().queryBillAddressHandler(model, 'SI', view.shipperLine2, view.shipperLine3, view.shipperLine4, view.shipperLine5, view.shipperLine6, view.consigneeLine2, view.consigneeLine3, view.consigneeLine4, view.consigneeLine5, view.consigneeLine6, view.notifyLine2, view.notifyLine3, view.notifyLine4, view.notifyLine5, view.notifyLine6)

    this.getCustomerType()
    this.loadCustomerContacts()// 加载联系人
    this.loadWarehouseInfo()
    this.loadCompanyOffice()
    this.loadCustomerRemarks()
    //    CARGO-2880关账控制：关账后，基本页面里的销售公司、销售员、操作部门不允许修改
    this.loadIsWithinClosingAccountDate()
    if (model && isNewInstance) {
      // this.selectDefaultCutomJobType()
      // 复制业务时校验新业务岗位角色在当前分公司是否有对应的岗位权限
      if (this.view.action === 'copy') {
        if (model.csr > 0) {
          this.view.$nextTick(() => {
            this.view.$refs.csr.executeAfterLoad(data => {
              if (JobUtils.checkUserRolePrivilege(data, model.csr)) {
                model.csr = 0
                model.csrDepartment = 0
              }
            })
          })
        }
        if (model.dc > 0) {
          this.view.$nextTick(() => {
            this.view.$refs.dc.executeAfterLoad(data => {
              if (JobUtils.checkUserRolePrivilege(data, model.dc)) {
                model.dc = 0
                model.dcDepartment = 0
              }
            })
          })
        }
      }
    }
    this.sopConfig()
    this.loadWarehouseRegion(false)
    this.checkVesselLine()
  }
  /**
   * 加载job仓库信息
   */
  loadWarehouseInfo() {
    if (this.job === null) { return }

    this.loadWarehouseInfo2Handler()
  }
  loadWarehouseInfo2Handler() {
    if (this.job.warehouseInfo != null && this.job.warehouseInfo.length > 0) {
      this.job.warehouseCmp = this.job.warehouseInfo[0].warehouseCmp
    } else if (!StrUtils.isEmpty(this.job.uuid)) { // 排除主票上 避免新增小票操作 copy 主票warehouseCmp 被清空
      this.job.warehouseCmp = 0
    }
  }
  async sopConfig() {
    this.view.sopImageA = false
    this.view.sopImageB = false
    this.view.sopImageC = false

    SopPushConfig.findByOfficeId(this.context.office.officeId).then(data => {
      this.configSuccessHandler(data.sopPushConfig)
    })
  }
  configSuccessHandler(data) {
    if (data) {
      const sop = data
      if (sop) {
        this.view.sopConfigOpen = sop.ifAuto
      }
      // 是否开启信控
      if (this.view.configValue.creditOpen) {
        this.checkCredit()
      } else {
        if (sop) {
          let openA = false
          const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
          if (customer !== null && customer.ifOpenSop && this.view.sopConfigOpen) {
            openA = true
          }
          this.view.sopImageA = openA

          let open = false
          const destinationAgent = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.destinationAgent))
          if (destinationAgent !== null && destinationAgent.ifOpenSop && this.view.sopConfigOpen) {
            open = true
          }
          this.view.sopImageB = open

          let openC = false
          const designationAgentC = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.designationAgent))
          if (designationAgentC !== null && designationAgentC.ifOpenSop && this.view.sopConfigOpen) {
            openC = true
          }
          this.view.sopImageC = openC
        }
      }
    } else {
      this.checkCredit()
    }
  }

  loadCompanyOffice() {
    const job = this.job
    if (job.salesOffice > 0) {
      const office = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', job.salesOffice)
      if (office) {
        this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
      } else {
        this.view.txtSalesOffice = ''
      }
    }
  }
  // 加载客户类型
  async getCustomerType() {
    let company = await Company.getCompanyById(this.job.customerId)
    this.view.advancePaymentLabel = company && company.ifAdvancePayment ? this.view.$t('Partners.IfAdvancePayment') : ''
    this.view.stampPictureView.businessDocuments = []
    if (!company) {
      this.view.customerLevel.level = ''
      return
    }
    company = new Company(company)
    // CARGO-20788海运进口—海运操作接口优化测试反馈
    let customer = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
    this.view.customerLevel.level = ''
    this.view.customerLevel.customerName = ''
    if (customer) {
      customer = new Customer(customer)
      const customerType = await customer.getCustomerType()
      if (customerType) {
        this.view.customerLevel.level = customerType.typeId
        this.view.customerLevel.customerName = customerType.chineseName
      }
    }
    /* 获取合约状态 */
    Company.loadAgreementClientContract(company.uuid).then(async contracts => {
      if (contracts && contracts.length > 0) {
        const now = moment()
        const businessIds = []
        for (const item of contracts) {
          // 过滤出当前合作伙伴所有未到期的合同
          if (dateCompareYMD(item.endDate, now) >= 0) {
            businessIds.push(item.uuid)
          }
        }
        if (businessIds.length > 0) {
          findBusinessDocument({ businessIds: businessIds }).then(res => {
            const docs = res.data
            if (docs && docs.length > 0) {
              const useDocs = []
              for (const doc of docs) {
                if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                useDocs.push(doc)
              }
              this.view.stampPictureView.businessDocuments = useDocs
            }
          })
        }
        company.contractStatus = businessIds.length > 0 ? 2 : 1
        // if (res.data.find(p => dateCompare(p.endDate, now) > 0)) {
        //   company.contractStatus = 2
        // } else {
        //   company.contractStatus = 1
        // }
      } else {
        company.contractStatus = 0
      }

      const contractState = this.view.contractStatuses[Number(company.contractStatus)]
      this.view.contractStatusLabel = contractState ? contractState.label : ''
      this.view.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.job))
    })
  }

  checkCredit() {
    this.view.creditTip.showWarningImageA = false
    this.view.creditTip.showWarningImageB = false
    this.view.creditTip.showWarningImageC = false

    if (this.view.configValue.creditOpen) {
      const job = this.job
      // 委托单位
      if (job && job.customerId > 0) {
        this.checkCreditByCompany(job.customerId, 2)
      }
      // 指定货代理
      if (job && job.designationAgent > 0) {
        this.checkCreditByCompany(job.designationAgent, 3)
      }
      // 目的港代理
      if (job && job.destinationAgent > 0) {
        this.checkCreditByCompany(job.destinationAgent, 1)
      }
    }
  }
  /**
   * type代表不同的角色
   */
  checkCreditByCompany(companyId, type) {
    const callback = credit => {
      let checkCredit = false
      const company = this.context.companyList.find(p => p.cmpIdx === companyId)
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          const config = this.getCreditEDISetting()
          if (config.booking) {
            if (credit.amountExceeded) { tip += this.view.$t('Partners.limit') }
            if (credit.dateExceeded) { tip += this.view.$t('Partners.accountPeriod') }
            const toolTip = this.view.$t('Partners.parter') + tip + this.view.$t('SeaExport.HasExceeded')
            if (type === 1) {
              this.view.creditTip.showWarningImageB = true
              this.view.creditTip.warningImageBTip = toolTip
            } else if (type === 2) {
              this.view.creditTip.showWarningImageA = true
              if (company && company.ifOpenSop && this.view.sopConfigOpen) {
                this.view.sopImageA = true
              }
              this.view.creditTip.warningImageATip = toolTip
            } else if (type === 3) {
              this.view.creditTip.showWarningImageC = true
              this.view.creditTip.warningImageCTip = toolTip
            }
            checkCredit = true
          }
        }
      }
      if (!credit || !checkCredit) {
        if (company && company.ifOpenSop && this.view.sopConfigOpen) {
          if (type === 1) {
            this.view.sopImageB = true
          } else if (type === 2) {
            this.view.sopImageA = true
          } else if (type === 3) {
            this.view.sopImageC = true
          }
        }
      }
    }
    CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  getCreditEDISetting() {
    const setting = this.config.get('creditBlockEDI')
    const a = setting.split(',')
    const r = {}
    for (const o of a) {
      let lock = false
      if (o.split('-')[1] === '1') {
        lock = true
      }
      r[o.split('-')[0]] = lock
    }
    return r
  }

  // 委托单位选择项
  async customerIdEnterHandler(event) {
    this.view.customerLevel.level = ''
    this.view.customerLevel.customerName = ''
    this.view.advancePaymentLabel = ''
    this.view.contractStatus = 0
    this.view.contractStatusLabel = ''
    this.view.customerTip = ''
    this.view.contactList = []
    this.view.cargoSalesList = null
    this.job.customerContact = ''
    this.job.contactTelephone = ''
    this.job.contactFax = ''
    this.view.stampPictureView.businessDocuments = []
    if (this.job.customerId && parseInt(this.job.customerId) > 0) {
      this.job.preCustomerId = this.job.customerId
    }
    let company = this.context.companyList.find(p => p.cmpIdx === event.cmpIdx)
    if (company && company.incoTerm) {
      const incoTerm = company.incoTerm.split(',')
      if (incoTerm.length > 0) {
        this.job.incoTerm = incoTerm[0]
      }
    }
    // event.cmpIdx =0|| ‘’ company =undefine
    if (!company) {
      company = null
    }

    const job = this.job
    if (this.job == null) { return }

    this.view.sopImageA = false

    let changeFlag = false
    if ((company === null && this.job.customerId > 0) || (company !== null && event.cmpIdx !== job.customerId)) { changeFlag = true }

    if (this.view.configValue.creditOpen && event.cmpIdx > 0) {
      this.checkCreditByCompany(event.cmpIdx, 2)
    } else {
      if (company) {
        if (this.view.sopConfigOpen) {
          this.view.sopImageA = company.ifOpenSop
        }
      }
    }

    if (company) {
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 欧坚委托单位是否风险客户
      await JobUtils.checkRiskyCustomersByByCustomerId(company.cmpIdx, StrUtils.isEmpty(this.job.uuid))
      // 必须在此处 赋值 否则 isForbid =true  this.job.customerId = 0 控件无法清除选中项
      const oldCustomerId = this.job.customerId
      // 这个验证必须在 this.form.customerId = company.cmpIdx 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(this.job, 'customerId', this.view.$t('SeaExport.ConsignationCompany'), this.context.modifiedData, () => {
        this.context.reloadCharge = true
      }) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.job.customerId = company.cmpIdx

      const isForbid = await Contract.isContractExpiredForbidCreateJob(event.cmpIdx)
      if (isForbid) {
        this.job.customerId = 0
        this.view.$message.info(this.view.$t('Message.ContractExpireCannotCreated'))
        this.job.customerRemarks = ''
        return
      } else {
        // 用于 customerIdHandler 方法的判断
        this.job.customerId = oldCustomerId
      }

      // 合同限制校验：检查是否启用合同限制且可放号天数<=0
      const contractLimitEnabled = company.contractLimitEnabled
      const availableDays = company.availableReleaseDays

      // contractLimitEnabled 可能是 '1' 或 1
      if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
        // availableReleaseDays 可能是数字或字符串，需要转换
        const daysNum = parseInt(availableDays) || 0
        if (daysNum <= 0) {
          const companyName = company.chineseName || company.englishName || '该委托单位'
          this.view.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
          this.job.customerId = 0
          this.job.customerRemarks = ''
          return
        }
      }
    }
    /*    ImportConstants.getInstance().customerIdHandler(event, view.job, view.customerContacts,
      view.txtCustomerContact, view.txtContactTelephone, view.txtContactFax);*/
    await this.customerIdHandler(company, event.cmpIdx)

    if (company && company.cmpIdx && company.cmpIdx > 0) {
      if (changeFlag) {
        this.getCustomerType()
        this.loadCustomerPortDestinationAgents()
        this.loadCompanyUser()
        this.loadCustomerContacts()
        await this.loadCustomerSales()
      }
      this.checkNewJobCreditInfo()
    } else {
      job.salesOffice = 0
      job.sales = 0
      job.salesDepartment = 0
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
      }
      this.getTxtSalesPrompt()
    }
    JobUtils.loadCompanyCargoSales(this.view, job, this.isSpecifiedSalesBusiness, true)
  }

  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfo() {
    const job = this.job
    if (this.view.configValue.creditOpen && StrUtils.isEmpty(job.uuid)) {
      // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
      const checkResult = this.checkNewJobCreditInfoFunc(job)
      this.view.processingPromiseList.push(checkResult)
      try {
        await checkResult
      } finally {
        const index = this.view.processingPromiseList.indexOf(checkResult)
        if (index > -1) {
          this.view.processingPromiseList.splice(index, 1)
        }
      }
    }
  }
  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfoFunc(job) {
    const params = JobUtils.getCreditCheckJob(job)
    await canCreateByCreditInfoDetail(params).then(async res => {
      if (res.data > 0) {
        const msg = {
          dangerouslyUseHTMLString: true,
          message: await JobUtils.checkDateAndAmountExceeded(res.data),
          type: 'warning',
          duration: 5000
        }
        this.view.$message.warning(msg)
        job.customerId = 0
        job.customerRemarks = ''
        this.view.creditTip.showWarningImageA = false
      }
    })
  }
  async customerIdHandler(company, cmpIdx) {
    const job = this.job
    if (this.job.customerId === cmpIdx) {
      return
    }

    this.job.customerId = company == null ? 0 : cmpIdx
    job.customerRemarks = company === null ? '' : company.chineseName

    this.customerCl()

    if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code && !job.masterFlag) {
      if (company != null) {
        if (!this.isSpecifiedSalesBusiness && String(cache.config.get('ToExoSystem')) !== 'DLWL') {
          const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
          await new Company(company).getCustomerDetail()
          if (company.customerDetail.sales > 0) {
            const salseTemp = company.customerDetail.sales
            if (salseTemp) {
              const user = await User.getUserById(salseTemp)
              if (user && user.active) {
                this.job.sales = salseTemp
              }
            }
          }
        }
      }
    }
  }

  /**
   * 根据整拼类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
   */
  selectDefaultCutomJobType() {
    getSpecificBasicData(basicCacheKeys.basic_data_CutomJobType).then(data => {
      this.cutomJobTypeList = data
    })

    const options = this.cutomJobTypeList.filter(p => p.type === this.job.lob && p.containerLoadType === this.job.containerLoadType)
    if (options.length > 0) {
      this.job.customJobType = options[0].code
    }
  }
  loadIsWithinClosingAccountDate() {
    ClosingAccount.isContainClosedCharge(this.context.office.officeId, this.job.jobNo).then(res => {
      this.isWithinCloseAccountDate = Boolean(res.data)
    })
  }
  loadCustomerRemarks() {
    // queryCustomerRemarksHistoryHandler
    queryCustomerRemarksHistory().then(res => {
      this.view.customerRemarks = res.data
    })
  }
  async loadCustomerContacts() {
    const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
    this.view.contactList = []
    if (!company || !this.job.customerId) {
      return
    }

    this.view.contactList = await Company.loadContact(company.uuid)
    this.loadContractsResultHandler(company)
  }

  /**
   * 联系人信息
   * @returns {Promise<void>}
   */
  async customerCl() {
    if (this.job === null) return
    if (this.job.customerId === 0) return

    const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
    this.view.contactList = await Company.loadContact(company.uuid)
    this.onCustomerContactLoad()
  }

  onCustomerContactLoad() {
    let contact
    if (this.view.contactList && this.view.contactList.length > 0) {
      contact = this.getDefaultContact(this.view.contactList)
    }
    if (this.view.isEdit) {
      this.job.customerContact = contact ? contact.contactPerson : ''
      this.job.contactFax = contact ? contact.fax : ''
      this.job.contactTelephone = contact ? contact.telephone : ''
    }
  }

  loadContractsResultHandler(company) {
    // 防止串数据
    if (company) {
      if (company && company.cmpIdx !== this.job.customerId) { return }
    }

    if (company && this.view.contactList && this.view.contactList.length > 0) {
      if (StrUtils.isEmpty(this.job.customerContact)) {
        const contact = this.getDefaultContact(this.view.contactList)

        this.job.customerContact = contact ? contact.contactPerson : ''
        this.job.contactFax = contact ? contact.fax : ''
        this.job.contactTelephone = contact ? contact.telephone : ''
      }
    } else {
      this.job.customerContact = ''
      this.job.contactFax = ''
      this.job.contactTelephone = ''
    }
  }
  /**
   * 获取默认联系人
   */
  getDefaultContact(ary) {
    let rs = null
    if (ary && ary.length > 0) {
      rs = ary[0]
      for (const contact of ary) {
        if (contact.defaultContact) {
          rs = contact
          break
        }
      }
    }
    return rs
  }
  // 根据客户默认带出指定货代理
  async loadCustomerPortDestinationAgents() {
    if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        await new Company(company).getCustomerDetail()
        this.loadCustomerDetail1Handler(company.customerDetail)
      }
    }
  }

  async loadCustomerDetail1Handler(customerDetail) {
    if (customerDetail) {
      const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
      this.loadPortDestinationAgentsHandler(portDestinationAgents)
    }
  }
  loadPortDestinationAgentsHandler(portDestinationAgents) {
    if (!portDestinationAgents) { return }

    const job = this.job
    for (const agent of portDestinationAgents) {
      if (job.loadingPortCode === agent.destinationPort) {
        job.designationAgent = agent.destinationAgentId

        // 指定货带网管
        this.loadOverseaAgentDetailOwner(job.designationAgent)
        break
      }
    }
  }
  /**
   * 加载客户销售
   */
  async loadCustomerSales() {
    const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
    if (company) {
      if (!this.isSpecifiedSalesBusiness && String(cache.config.get('ToExoSystem')) !== 'DLWL' && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        // 加载销售
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }

        await new Company(company).getCustomerDetail()

        if (company.customerDetail !== null) {
          if (company.customerDetail.sales > 0) {
            const salseTemp = company.customerDetail.sales
            const user = this.userList.find(p => p.userId === salseTemp)

            if (user && user.active) {
              if (this.view.salesOfficeCheck) {
                const userList = this.view.salesList
                this.job.sales = 0
                for (const obj of userList) {
                  if (user.userId === obj.userId) {
                    this.job.sales = salseTemp
                  }
                }
              } else {
                this.job.sales = salseTemp
              }
              this.salesChangeHandler({ ...user, value: this.job.sales })
            }
          } else {
            this.job.salesOffice = 0
            this.job.sales = 0
            this.job.salesDepartment = 0
          }
        }
      }
    }
  }

  /**
   * 指定货 -> 加载网管
   */
  async loadOverseaAgentDetailOwner(companyId) {
    if (!this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === companyId)
      if (company) {
        const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
        this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
      }
    }
  }
  loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
    const data = { value: 0 }
    if (overseaAgentDetail) {
      // 添加指定货代理等级
      const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
      if (overseaAgentGrade) {
        this.job.agentLevel = overseaAgentGrade.chineseName
      }
      const userList = this.view.$refs.sales.options

      if (this.view.salesOfficeCheck) {
        this.job.sales = 0
        const user = userList.find(p => p.userId === overseaAgentDetail.owner)
        Object.assign(data, user)
        if (user && user.active) {
          this.job.sales = overseaAgentDetail.owner
        }
      } else {
        this.job.sales = overseaAgentDetail.owner
      }
    } else {
      this.job.sales = 0
    }
    this.salesChangeHandler(data)
  }
  /**
   * 当选择销售人员的时候自动关联该销售所在分公司
   */
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.view.branchOfficeCheck || (!this.view.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          if (department) {
            const office = await Office.getOfficeByUuid(department.officeUuid)
            job.salesOffice = office.officeId
            job.salesDepartment = department.departmentId
            this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
          }
        }
      }
    }
    this.dipatchChangedSalesEvent(data.userId || 0)
  }
  /**
   * 手动选择销售
   */
  dipatchChangedSalesEvent(sales) {
    // var salesEvent: CommonFormEvent = new CommonFormEvent('salesChanged')
    // salesEvent.data = sales
    // view.dispatchEvent(salesEvent)
  }
  /**
   * 按业务指定销售
   */
  async loadCompanyUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      } else {
        this.job.salesOffice = 0
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }
      }
    }
  }
  async loadCompanyUserHandler(companyUsers) {
    const job = this.job
    // 销售
    const salesList = []
    let salesDefaultId = 0
    // 客服
    const csrList = []
    let csrDefaultId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 自定义岗位1
    const userDefinedRoleId1List = []
    let userDefinedRoleId1 = 0
    // 自定义岗位2
    const userDefinedRoleId2List = []
    let userDefinedRoleId2 = 0
    // 自定义岗位3
    const userDefinedRoleId3List = []
    let userDefinedRoleId3 = 0
    // 自定义岗位4
    const userDefinedRoleId4List = []
    let userDefinedRoleId4 = 0
    // 自定义岗位5
    const userDefinedRoleId5List = []
    let userDefinedRoleId5 = 0
    // 自定义岗位6
    const userDefinedRoleId6List = []
    let userDefinedRoleId6 = 0
    // 自定义岗位7
    const userDefinedRoleId7List = []
    let userDefinedRoleId7 = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.view.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true) || []
    }
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.view.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              csrList.push(user)
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code) { // 自定义岗位1
              if (u.defaultUser) {
                userDefinedRoleId1 = u.userId
              }
              userDefinedRoleId1List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code) { // 自定义岗位2
              if (u.defaultUser) {
                userDefinedRoleId2 = u.userId
              }
              userDefinedRoleId2List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE3.code) { // 自定义岗位3
              if (u.defaultUser) {
                userDefinedRoleId3 = u.userId
              }
              userDefinedRoleId3List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE4.code) { // 自定义岗位4
              if (u.defaultUser) {
                userDefinedRoleId4 = u.userId
              }
              userDefinedRoleId4List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE5.code) { // 自定义岗位5
              if (u.defaultUser) {
                userDefinedRoleId5 = u.userId
              }
              userDefinedRoleId5List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE6.code) { // 自定义岗位6
              if (u.defaultUser) {
                userDefinedRoleId6 = u.userId
              }
              userDefinedRoleId6List.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE7.code) { // 自定义岗位7
              if (u.defaultUser) {
                userDefinedRoleId7 = u.userId
              }
              userDefinedRoleId7List.push(user)
            }
          }
        }
      }
    }

    // 自揽货时进行销售变更;指定货以指定货代理为准
    if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      // 销售
      this.view.salesList = salesList
      this.getTxtSalesPrompt()
      if (salesList.length > 0) {
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        this.view.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.sales)
          if (user) {
            this.salesChangeHandler({ ...user, value: user.userId })
          }
        })
      } else {
        // job.sales = 0
        // job.salesDepartment = 0
        // this.view.txtSalesOffice = ''
      }
    }
    // 客服
    if (csrList.length > 0) {
      if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        if (user) {
          this.csrChangeHandler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.csr = 0
      // job.csrDepartment = 0
    }

    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.cargoSalesId)
        if (user) {
          this.cargoSalesChargeHandler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.cargoSalesId = 0
      // job.cargoSalesOffice = 0
      // job.cargoSalesDepartment = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.opChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          OverseaCustomerUtils.overseaOpChangeHandler(this.view, { ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
    // 自定义岗位1
    if (userDefinedRoleId1List.length > 0) {
      job.userDefinedRoleId1 = userDefinedRoleId1 > 0 ? userDefinedRoleId1 : userDefinedRoleId1List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId1)
        this.userDefinedRoleId1Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId1 = 0
      // job.userDefinedRoleDept1 = 0
      // job.userDefinedRoleOffice1 = 0
    }
    // 自定义岗位2
    if (userDefinedRoleId2List.length > 0) {
      job.userDefinedRoleId2 = userDefinedRoleId2 > 0 ? userDefinedRoleId2 : userDefinedRoleId2List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId2)
        this.userDefinedRoleId2Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId2 = 0
      // job.userDefinedRoleDept2 = 0
      // job.userDefinedRoleOffice2 = 0
    }
    // 自定义岗位3
    if (userDefinedRoleId3List.length > 0) {
      job.userDefinedRoleId3 = userDefinedRoleId3 > 0 ? userDefinedRoleId3 : userDefinedRoleId3List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId3)
        if (user) {
          this.userDefinedRoleId3Handler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.userDefinedRoleId3 = 0
      // job.userDefinedRoleDept3 = 0
      // job.userDefinedRoleOffice3 = 0
    }
    // 自定义岗位4
    if (userDefinedRoleId4List.length > 0) {
      job.userDefinedRoleId4 = userDefinedRoleId4 > 0 ? userDefinedRoleId4 : userDefinedRoleId4List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId4)
        if (user) {
          this.userDefinedRoleId4Handler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.userDefinedRoleId4 = 0
      // job.userDefinedRoleDept4 = 0
      // job.userDefinedRoleOffice4 = 0
    }
    // 自定义岗位5
    if (userDefinedRoleId5List.length > 0) {
      job.userDefinedRoleId5 = userDefinedRoleId5 > 0 ? userDefinedRoleId5 : userDefinedRoleId5List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId5)
        if (user) {
          this.userDefinedRoleId5Handler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.userDefinedRoleId5 = 0
      // job.userDefinedRoleDept5 = 0
      // job.userDefinedRoleOffice5 = 0
    }
    // 自定义岗位6
    if (userDefinedRoleId6List.length > 0) {
      job.userDefinedRoleId6 = userDefinedRoleId6 > 0 ? userDefinedRoleId6 : userDefinedRoleId6List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId6)
        if (user) {
          this.userDefinedRoleId6Handler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.userDefinedRoleId6 = 0
      // job.userDefinedRoleDept6 = 0
      // job.userDefinedRoleOffice6 = 0
    }
    // 自定义岗位7
    if (userDefinedRoleId7List.length > 0) {
      job.userDefinedRoleId7 = userDefinedRoleId7 > 0 ? userDefinedRoleId7 : userDefinedRoleId7List[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId7)
        if (user) {
          this.userDefinedRoleId7Handler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.userDefinedRoleId7 = 0
      // job.userDefinedRoleDept7 = 0
      // job.userDefinedRoleOffice7 = 0
    }
  }

  getTxtSalesPrompt() {
    if ((Number(this.config.get('IsSpecifiedSalesBusiness')) === 1) && (this.view.$refs.sales.options.length === 0)) {
      this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
    } else {
      this.view.salesPrompt = ''
    }
  }
  sopChangeBookingAgentHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.designationAgent) {
      this.view.$message.warning(this.view.$t('SeaExport.ChooseDesignatedAgent'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.designationAgent, 'DesignationAgent').then(data => {
      this.pageAResultHandler(data)
    })
  }
  sopChangeCustomerIdHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.customerId) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectTheEntrustingCompany'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.customerId, 'customer').then(data => {
      this.pageBResultHandler(data)
    })
  }
  sopChangeHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.destinationAgent) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectDestinationAgent'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.destinationAgent, 'DestinationAgent').then(data => {
      this.pageCResultHandler(data)
    })
  }
  pageAResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.designationAgent, 'DesignationAgent')
  }
  pageBResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.customerId, 'customer')
  }
  pageCResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.destinationAgent, 'DestinationAgent')
  }
  pageResultHandler(contactList, cmpIdx, agent) {
    this.view.sopDialog.cmpIdx = cmpIdx
    this.view.sopDialog.agent = agent
    this.view.sopDialog.contactList = contactList
    this.view.sopDialog.resultFunction = value => {
      this.saveSop(value, agent)
    }
    this.view.sopDialog.visible = true
  }
  saveSop(value, agent) {
    if (agent) {
      const job = this.job
      switch (agent) {
        case 'customer':
          job.ifPushSop = value
          break
        case 'DestinationAgent':
          job.ifPushSopM = value
          break
        case 'DesignationAgent':
          job.ifPushSopZ = value
          break
        case 'PortOfLoadingAgent':
          job.ifPushSopQ = value
          break
      }
    }
  }
  /**
   * 销售部门修改后，调整分公司信息
   */
  departmentChargeHandler(event = null) {
    /* if (view.txtSalesDepartment.department && view.txtSalesDepartment.department.office) {
      var officeId:int = view.txtSalesDepartment.department.office.officeId;
      if (officeId != view.job.salesOffice) {
        this.view.txtSalesOffice = ''
        view.job.salesDepartment = view.txtSalesDepartment.departmentId;
        view.job.salesOffice = officeId;
        this.loadCompanyOffice()
      }
    }*/
  }

  /**
   * 操作分公司选择
   */
  opOfficeChangeHandler(event) {
    // todo 下拉框数据源已经实现了动态加载过程，所以下面的代码屏蔽掉即可
    // job.opOffice = view.ddlOpOffice.opOfficeId
    // view.txtOP.queryUser('role', 'op', null, view.ddlOpOffice.opOffice)
    // view.txtDc.queryUser('role', 'doc', null, view.ddlOpOffice.opOffice)
    // if (isEntrustOrder || job.salesOffice == 1) {
    //   view.txtCSR.queryUser('role', 'csr', null, view.ddlOpOffice.opOffice)
    //   //				view.txtOverseaOp.queryUser('role','overseaOp',null,view.ddlOpOffice.opOffice)	// 海外代理
    // }
  }

  /**
   * 操作改变
   */
  opChangeHandler(user) {
    const job = this.job
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      if (job.opOffice > 0) {
        new User(user).getUserDefaultDepartmentByOffice('role', 'siop', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      } else {
        new User(user).getDefaultDepartment('role', 'siop', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      }
    }
  }
  /**
   * 客服改变
   */
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.csrOffice = office ? office.officeId : 0
            job.csrDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.csrDepartment = dep ? dep.departmentId : 0
        job.csrOffice = office ? office.officeId : 0
      }
    }
  }

  /**
   * 单证改变
   */
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.dcOffice = office ? office.officeId : 0
            job.dcDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      }
    } else {
      job.dc = 0
      job.dcDepartment = 0
      job.dcOffice = 0
    }
  }
  /**
   * 航线改变
   */
  async txtPlannerChangeHandler(data) {
    const job = this.job
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'seaLine', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.plannerOffice = office ? office.officeId : 0
            job.plannerDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'seaLine')
        job.plannerDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.plannerOffice = office ? office.officeId : 0
      }
    } else {
      job.planner = 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
    }
  }

  /**
   * 仓库
   */
  async warehouseCmpChangeHandler(data) {
    const job = this.job
    job.warehouseCmp = data.value
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    this.view.warehouseNameList = []
    if (job.warehouseCmp > 0) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.warehouseCmp)
      if (companyCache) {
        getWarehouseDetail(companyCache.uuid).then(res => {
          if (res.data.length > 0) {
            this.view.warehouseNameList = res.data
          }
        })
      }
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    if (warehouse.warehouseCmp > 0) {
      job.warehouseName = warehouse.warehouseName
    } else {
      job.warehouseName = ''
    }
    this.addWarehouseToModifiedSet(warehouse)
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  // 将warehouseInfo从被修改的集合中移除
  removeWarehouseFromModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.warehouseInfo && modifiedData.warehouseInfo.includes(warehouse)) {
      const index = modifiedData.warehouseInfo.indexOf(warehouse)
      if (index > -1) {
        modifiedData.warehouseInfo.splice(index, 1)
      }
    }
  }
  txtDestinationAgentChangeHandler(data) {
    const job = this.job
    this.view.sopImageB = false
    this.view.creditTip.showWarningImageB = false

    job.destinationAgent = data.value

    if (this.view.configValue.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, 1)
    } else {
      this.view.sopImageB = false
      const company = this.companyList.find(p => p.cmpIdx === data.value)
      if (company) {
        if (this.view.sopConfigOpen) {
          this.view.sopImageB = company.ifOpenSop
        }
      }
    }
    OverseaCustomerUtils.destinationAgentChangeHandler(this.view)
  }

  /**
   * 指定货代理选择
   */
  async designationAgentChangeHandler(data) {
    const job = this.job

    this.view.sopImageC = false
    this.view.creditTip.showWarningImageC = false

    job.designationAgent = data.value
    await ImportConstants.designationAgentWithSalesHandler(job.designationAgent, this.job, this.view.salesOfficeCheck, this.view.salesList)

    // 手工处理 不在List的user
    if (this.job.sales > 0) {
      const user = this.userList.find(p => p.userId === this.job.sales)
      if (!this.view.salesList.find(p => p.userId === user.userId)) {
        this.view.salesList.push(user)
      }
      if (String(cache.config.get('ToExoSystem')) !== 'DLWL') {
        this.salesChangeHandler({ ...user, value: this.job.sales })
      }
    }

    if (this.view.configValue.creditOpen && job.designationAgent > 0) {
      this.checkCreditByCompany(job.designationAgent, 3)
    } else {
      const company = this.companyList.find(p => p.cmpIdx === job.designationAgent)
      this.view.sopImageC = false
      if (this.sopConfigOpen && company != null && company.ifOpenSop) {
        // 判断该合作伙伴是否开启SOP
        this.view.sopImageC = true
      }
    }
    console.log('=====push==this.view.salesList', this.view.salesList)
    OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this.view)
  }

  /**
   * 选择联系人
   * @param val
   */
  tfLinkmanHandler(val) {
    if (val) {
      const contact = this.view.contactList.find(p => p.customerContact === val)
      this.job.contactFax = contact ? contact.fax : ''
      this.job.contactTelephone = contact ? contact.telephone : ''
    }
  }
  /**
   * 揽货类型选择 cargoSource_Change
   */
  async cargoSourceChange(value) {
    // 自揽货
    if (value === CargoSource.SC_CARGO_SOURCE.code) {
      this.customerIdChangeNew()
      this.view.visibleDesignationAgent = false

      this.view.customerLabel1 = this.view.$t('SeaExport.ConsignationCompany')
      this.view.customerLabel2 = this.view.$t('SeaExport.ConsignationCompanyHeader')
    } else {
      // 货物类型变为指定货时，重置销售列表
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
      }

      this.view.visibleDesignationAgent = true

      this.view.customerLabel1 = this.view.$t('SeaExport.ActualNotifyParty')
      this.view.customerLabel2 = this.view.$t('SeaExport.ActualNotifyPartyHeader')
    }
    // 清空一些数据
    this.job.cargoSource = value
    this.job.designationAgent = 0
    this.loadCustomerPortDestinationAgents()
    this.checkNewJobCreditInfo()
    JobUtils.matchUserPortConfig(this.view, this.job)
  }

  /**
   * 委托单位选择（从写委托单位选择，去掉当前与分公司校验）
   */
  async customerIdChangeNew() {
    const job = this.job
    job.editCftMode = false
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)

    if (this.view.configValue.creditOpen && job.customerId > 0) {
      this.checkCreditByCompany(job.customerId, 2)
    } else {
      if (company) {
        this.view.sopImageA = false
        if (this.view.sopConfigOpen) {
          this.view.sopImageA = company.ifOpenSop
        }
      }
    }

    let changeFlag = false
    if ((company === null && job.customerId > 0) || (company != null)) {
      changeFlag = true
    }

    this.customerIdHandlerWithSalesOffice()

    if (company) {
      if (changeFlag) {
        this.getCustomerType()
        this.loadCustomerPortDestinationAgents()
        this.loadCompanyUser()
        this.loadCustomerContacts()
        this.loadCustomerSales()
      }
    } else {
      job.salesOffice = 0
      job.sales = 0
      job.salesDepartment = 0

      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
      }
      this.getTxtSalesPrompt()
    }
  }

  // 委托单位选择项
  customerIdHandlerWithSalesOffice() {
    this.customerCl()
  }
  /**
   * 卸货港选择
   */
  async dischargingPortCodeChange(evt) {
    const job = this.job
    if (Number(this.config.get('SyncPOD')) === 1) {
      job.destinationPortCode = job.dischargingPortCode
    } else {
      job.destinationPortCode = job.destinationPortCode || job.dischargingPortCode
    }
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const selPort = seaPorts.filter(p => p.code === job.dischargingPortCode)
    if (selPort && selPort.length > 0) {
      if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
        job.destinationPlace = selPort[0].englishName
      }
    }
    await this.loadWarehouseRegion(true)
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job)
  }
  async changeLoadingPortCode(data) {
    const job = this.job
    this.view.loadingPortChanged = false
    if (job.usCustomsClearance && job.loadingPortCode && data && data.value && data.value !== job.loadingPortCode) {
      this.view.loadingPortChanged = true
      job.loadingPortCode = data.value
      if (!job.usCustomsClearanceList || job.usCustomsClearanceList.length === 0) {
        await new SeaImportJob(job).getUsCustomsClearanceList()
      }
      JobUtils.updateUsCustomsClearanceList(job)
    } else {
      if (data) {
        job.loadingPortCode = data.value || ''
      } else {
        job.loadingPortCode = ''
      }
    }
    // 当新增业务时 同步起运港到提单
    if (job.uuid) {
      return
    }
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)

    const hbl = await new SeaImportJob(job).getMainHbl(false)
    if (hbl) {
      if (job.loadingPortCode && this.job.loadingPortCode.length > 0) {
        const hblPort = seaPorts.filter(p => p.code === job.loadingPortCode)
        if (hblPort && hblPort.length > 0) {
          hbl.loadingPort = hblPort[0].englishName
        }
      }
    }

    const mdoc = await new SeaImportJob(this.job).getMainMbl(false)
    if (mdoc) {
      if (job.loadingPortCode && job.loadingPortCode.length > 0) {
        const mblPort = seaPorts.filter(p => p.code === job.loadingPortCode)
        if (mblPort && mblPort.length > 0) {
          mdoc.loadingPort = mblPort[0].englishName
        }
      }
    }
    JobUtils.matchUserPortConfig(this.view, job)
    JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }))
  }
  /**
   * 提单卸货港
   */
  async changeDischargingPort2(event) {
    const job = this.job

    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)

    const hbl = await new SeaImportJob(job).getMainHbl(false)
    if (hbl) {
      if (hbl.state > 1) return
      if (job.dischargingPortCode && this.job.dischargingPortCode.length > 0) {
        const hblPort = seaPorts.filter(p => p.code === job.dischargingPortCode)
        if (hblPort && hblPort.length > 0) {
          hbl.dischargingPort = hblPort[0].englishName
          hbl.destinationPort = hblPort[0].englishName
        }
      }
    }

    const mdoc = await new SeaImportJob(this.job).getMainMbl(false)
    if (mdoc) {
      if (mdoc.state > 1) return
      if (job.dischargingPortCode && job.dischargingPortCode.length > 0) {
        const mblPort = seaPorts.filter(p => p.code === job.dischargingPortCode)
        if (mblPort && mblPort.length > 0) {
          mdoc.dischargingPort = mblPort[0].englishName
          mdoc.destinationPort = mblPort[0].englishName
        }
      }
    }
  }

  /**
   * 提单交货地
   */
  async changeDestinationPort() {
    const job = this.job

    const hbl = await new SeaImportJob(job).getMainHbl(false)
    if (hbl) {
      if (hbl.state > 1) return
      hbl.destinationPort = job.destinationPlace
    }

    const mdoc = await new SeaImportJob(this.job).getMainMbl(false)
    if (mdoc) {
      if (mdoc.state > 1) return
      mdoc.destinationPort = job.destinationPlace
    }
  }

  destinationPortCodeEasyChange(data) {
    // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
    if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
      this.job.destinationPlace = data.englishName
    }
  }

  /**
   * 根据提单号获取船名航次
   */
  getMblVesselEqEvent() {
    if (StrUtils.isEmpty(this.job.vessel) || StrUtils.isEmpty(this.job.voyageFlight)) {
      this.view.$message.show(this.view.$t('SeaExport.checkVslVoy'))
    }
    // 此功能不要了 SeaImportJob.getEtaAccordingToVesselVoyage(view.txtVessel.text, view.txtVoyage.text.replace("V.",""), new mx.rpc.Responder(getMblVesselVoyageResult, onFailed));
  }

  /**
   * 单号抄录
   */
  onExcerption() {
    this.view.importPromptTitleDialog.visible = true
  }

  /**
   * 单号抄录
   */
  async onExcerptionChangeFunc(data) {
    this.job.shipperCode = data.shipperCode
    this.job.shipperLine1 = data.shipperLine1
    this.job.shipperLine2 = data.shipperLine2
    this.job.shipperLine3 = data.shipperLine3
    this.job.shipperLine4 = data.shipperLine4
    this.job.shipperLine5 = data.shipperLine5
    this.job.shipperLine6 = data.shipperLine6
    this.job.shipperLine7 = data.shipperLine7

    this.job.consigneeCode = data.consigneeCode
    this.job.consigneeLine1 = data.consigneeLine1
    this.job.consigneeLine2 = data.consigneeLine2
    this.job.consigneeLine3 = data.consigneeLine3
    this.job.consigneeLine4 = data.consigneeLine4
    this.job.consigneeLine5 = data.consigneeLine5
    this.job.consigneeLine6 = data.consigneeLine6
    this.job.consigneeLine7 = data.consigneeLine7

    this.job.notifyCode = data.notifyCode
    this.job.notifyLine1 = data.notifyLine1
    this.job.notifyLine2 = data.notifyLine2
    this.job.notifyLine3 = data.notifyLine3
    this.job.notifyLine4 = data.notifyLine4
    this.job.notifyLine5 = data.notifyLine5
    this.job.notifyLine6 = data.notifyLine6
    this.job.notifyLine7 = data.notifyLine7

    const hDoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hDoc) {
      hDoc.shipperCode = this.job.shipperCode
      hDoc.consigneeCode = this.job.consigneeCode
      hDoc.notifyCode = this.job.notifyCode

      hDoc.shipperLine1 = data.shipperLine1
      hDoc.shipperLine2 = data.shipperLine2
      hDoc.shipperLine3 = data.shipperLine3
      hDoc.shipperLine4 = data.shipperLine4
      hDoc.shipperLine5 = data.shipperLine5
      hDoc.shipperLine6 = data.shipperLine6
      hDoc.shipperLine7 = data.shipperLine7

      hDoc.consigneeLine1 = data.consigneeLine1
      hDoc.consigneeLine2 = data.consigneeLine2
      hDoc.consigneeLine3 = data.consigneeLine3
      hDoc.consigneeLine4 = data.consigneeLine4
      hDoc.consigneeLine5 = data.consigneeLine5
      hDoc.consigneeLine6 = data.consigneeLine6
      hDoc.consigneeLine7 = data.consigneeLine7

      hDoc.notifyLine1 = data.notifyLine1
      hDoc.notifyLine2 = data.notifyLine2
      hDoc.notifyLine3 = data.notifyLine3
      hDoc.notifyLine4 = data.notifyLine4
      hDoc.notifyLine5 = data.notifyLine5
      hDoc.notifyLine6 = data.notifyLine6
      hDoc.notifyLine7 = data.notifyLine7
    }
  }
  /**
   * @public
   * 代码检索
   */
  onCodeSearch() {
    this.view.billAddressDialog.visible = true
  }

  codeSearchCallback(data) {
    let billAddress = null
    if (data.shipperInfo) {
      billAddress = data.shipperInfo
      let fromIndex = 0
      let i = 1
      for (; i < 6; ++i) {
        const index = billAddress.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = billAddress.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = billAddress.substring(fromIndex)

      this.job.shipperCode = data.shipperCode

      this.shipperAddrChangeFunc(data.shipperInfo)
    }
    if (data.consigneeInfo) {
      billAddress = data.consigneeInfo
      let fromIndex = 0
      let i = 1
      for (; i < 5; ++i) {
        const index = billAddress.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = billAddress.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = billAddress.substring(fromIndex)
      this.job.consigneeCode = data.consigneeCode
      this.consigneeAddrChangeFunc(data.consigneeInfo)
    }
    if (data.notifyInfo) {
      billAddress = data.notifyInfo
      let fromIndex = 0
      let i = 1
      for (; i < 5; ++i) {
        const index = billAddress.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = billAddress.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = billAddress.substring(fromIndex)
      this.job.notifyCode = data.notifyCode
      this.notifyChangeFunc(data.notifyInfo)
    }
  }

  /**
   * 发货人选择
   */
  async shipperAutoCompleteChange(data) {
    const form = this.job
    form.shipperId = data.value
    if (!form.shipperId) {
      return
    }
    const company = new Company(data)
    const manifestAddress = await company.getManifestAddress()
    if (manifestAddress) {
      form.shipperLine1 = manifestAddress.addressLine1
      form.shipperLine2 = manifestAddress.addressLine2
      form.shipperLine3 = manifestAddress.addressLine3
      form.shipperLine4 = manifestAddress.addressLine4
      form.shipperLine5 = manifestAddress.addressLine5
      form.shipperLine6 = manifestAddress.addressLine6
      form.shipperLine7 = manifestAddress.addressLine7
    } else {
      form.shipperLine1 = ''
      form.shipperLine2 = ''
      form.shipperLine3 = ''
      form.shipperLine4 = ''
      form.shipperLine5 = ''
      form.shipperLine6 = ''
      form.shipperLine7 = ''
    }
    this.shipperAddrChangeFunc()
  }

  async shipperAddrChangeFunc() {
    if (!this.view.isEdit) {
      return
    }
    const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hdoc) {
      hdoc.shipperCode = this.job.shipperCode
      hdoc.shipperLine1 = this.job.shipperLine1
      hdoc.shipperLine2 = this.job.shipperLine2
      hdoc.shipperLine3 = this.job.shipperLine3
      hdoc.shipperLine4 = this.job.shipperLine4
      hdoc.shipperLine5 = this.job.shipperLine5
      hdoc.shipperLine6 = this.job.shipperLine6
    }
  }

  async consigneeAutoCompleteChange(data) {
    const form = this.job
    form.consigneeId = data.value
    if (!form.consigneeId) {
      return
    }
    const company = new Company(data)
    const manifestAddress = await company.getManifestAddress()
    if (manifestAddress) {
      form.consigneeLine1 = manifestAddress.addressLine1
      form.consigneeLine2 = manifestAddress.addressLine2
      form.consigneeLine3 = manifestAddress.addressLine3
      form.consigneeLine4 = manifestAddress.addressLine4
      form.consigneeLine5 = manifestAddress.addressLine5
      form.consigneeLine6 = manifestAddress.addressLine6
      form.consigneeLine7 = manifestAddress.addressLine7
    } else {
      form.consigneeLine1 = ''
      form.consigneeLine2 = ''
      form.consigneeLine3 = ''
      form.consigneeLine4 = ''
      form.consigneeLine5 = ''
      form.consigneeLine6 = ''
      form.consigneeLine7 = ''
    }
    this.consigneeAddrChangeFunc()
  }
  /**
   * 收货人选择
   */
  async consigneeAddrChangeFunc() {
    if (!this.view.isEdit) {
      return
    }
    const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hdoc) {
      hdoc.consigneeCode = this.job.consigneeCode
      hdoc.consigneeLine1 = this.job.consigneeLine1
      hdoc.consigneeLine2 = this.job.consigneeLine2
      hdoc.consigneeLine3 = this.job.consigneeLine3
      hdoc.consigneeLine4 = this.job.consigneeLine4
      hdoc.consigneeLine5 = this.job.consigneeLine5
      hdoc.consigneeLine6 = this.job.consigneeLine6
    }
  }
  /**
   * 通知人选择
   */
  async notifyAutoCompleteChange(data) {
    const form = this.job
    form.notifyId = data.value
    if (!form.notifyId) {
      return
    }
    const company = new Company(data)
    const manifestAddress = await company.getManifestAddress()
    if (manifestAddress) {
      form.notifyLine1 = manifestAddress.addressLine1
      form.notifyLine2 = manifestAddress.addressLine2
      form.notifyLine3 = manifestAddress.addressLine3
      form.notifyLine4 = manifestAddress.addressLine4
      form.notifyLine5 = manifestAddress.addressLine5
      form.notifyLine6 = manifestAddress.addressLine6
      form.notifyLine7 = manifestAddress.addressLine7
    } else {
      form.notifyLine1 = ''
      form.notifyLine2 = ''
      form.notifyLine3 = ''
      form.notifyLine4 = ''
      form.notifyLine5 = ''
      form.notifyLine6 = ''
      form.notifyLine7 = ''
    }
    this.notifyChangeFunc()
  }

  /**
   * 通知人选择
   */
  async notifyChangeFunc() {
    if (!this.view.isEdit) {
      return
    }
    const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hdoc) {
      hdoc.notifyCode = this.job.notifyCode
      hdoc.notifyLine1 = this.job.notifyLine1
      hdoc.notifyLine2 = this.job.notifyLine2
      hdoc.notifyLine3 = this.job.notifyLine3
      hdoc.notifyLine4 = this.job.notifyLine4
      hdoc.notifyLine5 = this.job.notifyLine5
      hdoc.notifyLine6 = this.job.notifyLine6
    }
  }

  /**
   * 收货人代码
   */
  qConsigneeCode_focusOutHandler() {
    if (!this.job.notifyCode) {
      this.job.notifyCode = this.job.consigneeCode
    }
  }

  /**
   * 收货人地址
   */
  qConsigneeAddr_focusOutHandler() {
    if (!this.job.notifyLine1) {
      this.job.notifyLine1 = this.job.consigneeLine1
    }
  }
  // 件数变化同步 hbl
  quantityFocusInHandler() {
    this.job.quantityContract = this.job.quantityActual
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }

  // 包装变化
  chargePacking() {
    SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), true)
  }

  // 重量变化
  weightFocusInHandler() {
    this.calculateChargeWeight(true)
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }

  // 体积变化
  cubageFocusInHandler(syncChargeWeightToCharge = true) {
    this.calculateChargeWeight(syncChargeWeightToCharge)
    if (this.job.chargeWeight <= this.defaultChargeCubage) {
      this.job.chargeCubage = this.defaultChargeCubage
    }
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }
  // 计费重量变化
  async chargeWeightChangeHandler() {
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
    await this.syncChargeWeightToCharge()
  }

  //    英文品名变化
  async txtCargoEnglishNameChangeHandler() {
    SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), true)
    const mdoc = await new SeaImportJob(this.job).getMainMbl()
    if (mdoc) {
      mdoc._cargoEnglishNameTime = new Date()
    }
  }

  /**
   * @private
   * 计算计费重量
   */
  calculateChargeWeight(syncChargeWeightToCharge = true) {
    const chargeWeight = this.job.weightContract / 1000

    // 毛重或体积未填写时
    if (isNaN(this.job.cubageContract) && isNaN(this.job.weightContract)) {
      this.job.chargeWeight = 0
      return
    }
    if (isNaN(this.job.cubageContract)) {
      this.job.chargeWeight = chargeWeight
      return
    }
    if (isNaN(this.job.weightContract)) {
      this.job.chargeWeight = this.job.cubageContract
      return
    }

    if (chargeWeight > this.job.cubageContract) {
      this.job.chargeWeight = chargeWeight
    } else {
      this.job.chargeWeight = this.job.cubageContract
    }
    if (syncChargeWeightToCharge) {
      this.syncChargeWeightToCharge()
    }
  }

  /**
   * 整拼类型选择
   */
  qCargoType_Change(data) {
    const containerLoadType = data.value
    this.job.containerLoadType = containerLoadType
    if (containerLoadType === 'LCL' || containerLoadType === BULK_CARGO_TYPE.code) {
      /* 清空seaEQ */
      if (!this.job.delseaEQUuids) {
        this.job.delseaEQUuids = []
      }
      for (const item of this.job.seaEQ) {
        this.job.delseaEQUuids.push(item.uuid)
      }
      this.job.seaEQ.splice(0, this.job.seaEQ.length)
      /* 清空containers */
      if (!this.job.delContainerUuids) {
        this.job.delContainerUuids = []
      }
      for (const item of this.job.containers) {
        this.job.delContainerUuids.push(item.uuid)
      }
      this.job.containers.splice(0, this.job.containers.length)
      // 清空containerUsages
      this.job.containerUsages.splice(0, this.job.containerUsages.length)
    }
    // 整拼类型不为散杂货，但是散杂货信息有值时清空
    if (containerLoadType !== BULK_CARGO_TYPE.code && this.view.cargoBulkDetailList && this.view.cargoBulkDetailList.length > 0) {
      this.view.cargoBulkDetailList = []
    }
    this.job.masterFlag = containerLoadType === 'CON'
    console.log('===qCargoType_Change=', this.job.masterFlag)
    // 改变自定义业务类型
    this.selectDefaultCutomJobType()
    // 判断客户是否有维护默认的主单和分单运输条款
    const shippingTermList = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
    if (shippingTermList && shippingTermList.length > 0) {
      for (const shippingTerm of shippingTermList) {
        let isFind = false
        const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
        if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
          for (const item of shippingTermOperationTypes) {
            if (item.containerLoadType === containerLoadType && item.mbl && item.lob === 'SI') {
              isFind = true
              break
            }
          }
        }
        if (isFind) {
          this.job.freightTermMBL = shippingTerm.code
          break
        }
      }
      for (const shippingTerm of shippingTermList) {
        let isFind = false
        const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
        if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
          for (const item of shippingTermOperationTypes) {
            if (item.containerLoadType === containerLoadType && !item.mbl && item.lob === 'SI') {
              isFind = true
              break
            }
          }
        }
        if (isFind) {
          this.job.freightTermHBL = shippingTerm.code
          break
        }
      }
    }
    // 切换基本页签 handleTabClick
    this.view.$emit('containerLoadTypeEvent', this.job)
    this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
  }

  /**
   * 分单运输条款
   */
  freightTermHBLChange(data) {
    const value = data.value
    this.job.freightTermHBL = value

    const _hCargoDoc = this.job.cargoDoc
    const hbl2CargoDocs = []
    if (_hCargoDoc) {
      for (let i_hCargoDoc; i_hCargoDoc < _hCargoDoc.length; ++i_hCargoDoc) {
        const item_hCargoDoc = _hCargoDoc[i_hCargoDoc]
        if (item_hCargoDoc.docType === CargoDocConsts.HBL) {
          item_hCargoDoc.freightTermHBL = value
        } else if (item_hCargoDoc.docType === CargoDocConsts.HBL2) {
          hbl2CargoDocs.push(item_hCargoDoc)
        }
      }
      if (hbl2CargoDocs.length > 0) {
        const hbl2CargoDoc = hbl2CargoDocs[0]
        hbl2CargoDoc.freightTermHBL = value
      }
    }
  }

  /**
   * 主单运输条款
   */
  paymentTermMBLChange(data) {
    if (this.job) {
      this.job.paymentTermMBL = data.value
      this.paymentPlaceBLShowChange()
    }
  }
  paymentPlaceBLShowChange() {
    this.view.isShowAcPaymentPlaceBL = false
  }

  /**
   * 主单付款地点
   */
  async fieldChangeHandler() {
    // const job = new SeaImportJob(this.job)
    // const mdoc = await job.getMainMbl(true)
    // mdoc.paymentPlaceBL = job.paymentPlaceMbl
    // const mbl2 = await job.getCargoDocByType(CargoDocConsts.MBL2, false)
    // if (mbl2 != null) {
    //   mbl2.paymentPlaceBL = mdoc.paymentPlaceBL
    // }
  }
  /**
   * @protected
   * 选择换单日期时锁定ETA ETD
   */
  dfCustDate_focusOutHandler() {
    if (this.job.transDate) {
      this.view.controllerEnable.dfETD = false
    } else {
      this.view.controllerEnable.dfETD = true
    }
  }

  /**
   * 投保
   */
  async toInsure() {
    let mblDoc = null
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === 'MBL') {
        mblDoc = doc
        break
      }
    }
    if (mblDoc == null) {
      return
    }
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      docUuid: mblDoc.uuid,
      billno: this.job.mbl,
      insureType: 'DOC'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.config.get('isPlatformInsurance')) === 3) {
    //   let mblDoc = null
    //   for (const doc of this.job.seaCargoDoc) {
    //     if (doc.docType === 'MBL') {
    //       mblDoc = doc
    //       break
    //     }
    //   }
    //   if (mblDoc == null) {
    //     return
    //   }
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: this.view.$store.getters.currentOfficeId,
    //     docUuid: mblDoc.uuid,
    //     billno: this.job.mbl,
    //     insureType: 'DOC'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // todo  前端埋点日志 LogStores.sendFunctionClickLogStoresByLabel('SI-基本-投保')
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   let mbl = null
    //   for (const doc of this.job.seaCargoDoc) {
    //     if (doc.docType === 'MBL') {
    //       mbl = doc
    //       break
    //     }
    //   }
    //   if (Object.prototype.hasOwnProperty.call(this.job, 'containerUsages')) {
    //     for (const usage of this.job.containerUsages) {
    //       delete usage.container
    //     }
    //   }
    //   if (Object.prototype.hasOwnProperty.call(this.job, 'containers')) {
    //     for (const container of this.job.containers) {
    //       delete container.containerUsages
    //     }
    //   }
    //   SeaImCargoDoc.toInsure(this.user.tenantName, mbl, this.job, this.context.office).then(data => {
    //     this.insureSuccessHandler(data)
    //   })
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }
  /**
   * 投保成功
   */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.view.$message.warning(result)
  //   }
  // }
  /**
   * 修改货物信息
   */
  async cargoCodeChange(data) {
    if (data === null || data === '') {
      this.view.job.cargoCode = ''
      this.view.job.cargoName = ''
    } else {
      const cargoInformation = getObjectByCache(basicCacheKeys.basic_data_CargoInformation, 'code', data)
      if (cargoInformation) {
        this.view.job.cargoCode = cargoInformation.code
        this.view.job.cargoName = cargoInformation.englishName
      }
    }
  }
  // 加载仓库航线关联信息,并初始化仓库下拉框数据
  async loadWarehouseRegion(updateWarehousing = false) {
    const job = this.job
    if (parseInt(this.config.get('AssociatedRoute')) !== 1 || !job.dischargingPortCode) return
    const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
    if (port) {
      const region = this.regionList.find(p => p.code === port.region)
      if (region && region.warehouseRegions && region.warehouseRegions.length > 0) {
        if (region.warehouseRegions.length === 1) {
          const warehouse = this.companyList.find(p => p.uuid === region.warehouseRegions[0].companyUuid)
          if (warehouse) {
            if (updateWarehousing && job.warehousing) { // 新增
              this.warehouseCmpChangeHandler({ value: warehouse.cmpIdx })
            }
          }
        } else {
          if (updateWarehousing && job.warehousing) {
            let defaultWarehouseCompany = null
            const warehouseCompanyList = []
            for (const warehouseRegion of region.warehouseRegions) {
              const warehouseCompany = this.companyList.find(p => p.uuid === warehouseRegion.companyUuid)
              if (warehouseCompany) {
                if (warehouseCompanyList.findIndex(p => p.uuid === warehouseCompany.uuid) < 0) {
                  warehouseCompanyList.push(warehouseCompany)
                }
              }
            }
            if (warehouseCompanyList && warehouseCompanyList.length > 0) {
              for (const warehouseCompany of warehouseCompanyList) {
                await new Company(warehouseCompany).getWarehouseDetail()
                const defaultWarehouse = Company.defaultWarehouse(warehouseCompany)
                if (defaultWarehouse) {
                  defaultWarehouseCompany = warehouseCompany
                  break
                }
              }
              if (!job.warehouseCmp || job.warehouseCmp === 0) {
                if (defaultWarehouseCompany) {
                  await this.warehouseCmpChangeHandler({ value: defaultWarehouseCompany.cmpIdx })
                } else {
                  await this.warehouseCmpChangeHandler({ value: 0 })
                }
              }
            }
          }
        }
      }
    }
  }
  // 计费重量变化，是否同步费用
  syncChargeWeightToCharge() {
    let chargeFlag = false
    for (const charge of this.job.charges) {
      if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
          !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid &&
          !charge.verifiedAmount && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code && !charge.paidOff && charge.chargeState === 0 && !charge.relatedMbl &&
          ((charge.receivable && this.job.receivableChargeLockedStatus === 0) || (!charge.receivable && this.job.payableChargeLockedStatus === 0))) {
        chargeFlag = true
        break
      }
    }
    if (chargeFlag) {
      this.view.$confirm(this.view.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const charges = []
        for (const charge of this.job.charges) {
          if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
              !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
              !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 && !charge.relatedMbl &&
              ((charge.receivable && this.job.receivableChargeLockedStatus === 0) || (!charge.receivable && this.job.payableChargeLockedStatus === 0))) {
            charge.quantity = this.job.chargeWeight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
            charges.push(charge)
          }
        }
        if (charges && charges.length > 0 && this.context.modifiedData) {
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
        }
        this.view.context.reloadCharge = true
      }).catch(() => {
      })
    }
  } catch(e) {
    // console.log('syncChargeWeightToCharge error', e)
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept1 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice1 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice1 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept2 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice2 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice2 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段3
  async userDefinedRoleId3Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId3 = value || 0
    job.userDefinedRoleDept3 = 0
    job.userDefinedRoleOffice3 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept3 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice3 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
        job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice3 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段4
  async userDefinedRoleId4Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId4 = value || 0
    job.userDefinedRoleDept4 = 0
    job.userDefinedRoleOffice4 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept4 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice4 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
        job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice4 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段5
  async userDefinedRoleId5Handler(data) {
    const job = this.job
    job.userDefinedRoleId5 = data.value || 0
    job.userDefinedRoleDept5 = 0
    job.userDefinedRoleOffice5 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept5 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice5 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
        job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice5 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段6
  async userDefinedRoleId6Handler(data) {
    const job = this.job
    job.userDefinedRoleId6 = data.value || 0
    job.userDefinedRoleDept6 = 0
    job.userDefinedRoleOffice6 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept6 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice6 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
        job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice6 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段7
  async userDefinedRoleId7Handler(data) {
    const job = this.job
    job.userDefinedRoleId7 = data.value || 0
    job.userDefinedRoleDept7 = 0
    job.userDefinedRoleOffice7 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept7 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice7 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
        job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice7 = office ? office.officeId : 0
      }
    }
  }
  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }
  async changeProject() {
    if (this.view.isProjectLinkedCustomer) {
      const company = await getPartnerByPoNo(this.job.poNo).then(res => {
        return res.data
      })
      if (company && this.job.customerId !== company.cmpIdx && company.active) {
        await this.customerIdEnterHandler(company)
      }
    }
  }
  clearPoNo() {
    if (this.view.isProjectLinkedCustomer) {
      this.job.poNo = ''
      this.job.projectName = ''
    }
  }
}
